import { types, getEnv } from 'mobx-state-tree';
import { ICommonAppEnvWithSoundService } from '.';
import { ICommonAppEnvWithSBBaseApi } from './index';

export const SoundUI = types.model({
    isMute: types.boolean
}).actions(self => {

    const env = getEnv<ICommonAppEnvWithSBBaseApi>(self);
    const soundService = getEnv<ICommonAppEnvWithSoundService>(self).soundService;
    const loggingService = env.loggingService;

    const setIsMute = (isMute: boolean) => {
        self.isMute = isMute;
        soundService.setIsMute(isMute);
        saveIsMutedToSetting(isMute);
    }

    const loadIsMuteFromSetting = (): boolean => {
        try {
            let value = env.localStorage.getItem("live-sound-muted");
            return value === "true";
        }
        catch (e) {
            loggingService.error(e);
        }
        return false;
    }

    const saveIsMutedToSetting = (isMute: boolean): void => {
        try {
            if (isMute) {
                env.localStorage.setItem("live-sound-muted", "true");
            } else {
                env.localStorage.removeItem("live-sound-muted");
            }
        }
        catch (e) {
            loggingService.error(e);
        }
    }

    const initFromSettings = (): void => {
        setIsMute(loadIsMuteFromSetting());
    }

    return {
        initFromSettings,
        setIsMute
    }
});